import NetInfo from '@react-native-community/netinfo'
import { usePathname } from 'expo-router'
import { useEffect } from 'react'

import { useToast } from '@/src/general/components/ToastContext'
import { useTranslate } from '@/src/lang/useTranslate'

import { ICON } from '../enums/icons'

export const InternetNotAvailable = () => {
  const { addToast } = useToast()
  const { t } = useTranslate()
  const pathname = usePathname()
  const { isInternetReachable } = NetInfo.useNetInfo()

  // FIXME : Adding t in hook dependencies cause maximum depth updates
  const translatedText = t('app-service.not-connected')

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>

    if (isInternetReachable === false) {
      timeoutId = setTimeout(async () => {
        const { isInternetReachable: latestInternetStatus } = await NetInfo.fetch()
        if (latestInternetStatus === false) {
          addToast({
            message: translatedText,
            colors: 'danger',
            iconName: ICON.WIFI_OFF,
          })
        }
      }, 3000)
    }

    return () => clearTimeout(timeoutId)
  }, [isInternetReachable, addToast, translatedText, pathname])

  return null
}
